import React from 'react';

const BiLouiseSmallGray = ({ fill }: { fill: string }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Logo">
        <path
          id="Vector"
          d="M13.3413 3.87422H8.97774V1.78711L2.63818 8.13111V12.1453H6.99818V14.2316L11.2133 10.0164H13.3413V3.87422ZM4.76618 10.0164V6.00222H11.2133V10.0164H4.76618Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default BiLouiseSmallGray;
